const LOGO_URL = "/logo-aldebran.png";

export const Logo = ({ compact = false }) => (
  <img
    src={LOGO_URL}
    alt="Aldebran — innovative engineering"
    data-testid="logo"
    className={`w-auto ${compact ? "h-9" : "h-11"}`}
  />
);
